/**
 * Página de Análise Tributária
 * Utiliza IA para recomendar melhor estrutura jurídica
 */

import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Alert,
  Divider,
} from '@mui/material';
import { Analytics as AnalyticsIcon } from '@mui/icons-material';

/**
 * Página de Análise Tributária
 */
const Analise = () => {
  const [loading, setLoading] = useState(false);
  const [analise, setAnalise] = useState(null);
  const [error, setError] = useState('');

  /**
   * Solicita análise tributária
   */
  const handleAnalisar = async () => {
    setLoading(true);
    setError('');

    try {
      // TODO: Chamar API real
      // Simulação de resposta
      setTimeout(() => {
        setAnalise({
          estruturaAtual: 'Pessoa Física',
          estruturaRecomendada: 'Simples Nacional',
          justificativa: `Com base no seu faturamento mensal médio de R$ 15.000,00 e despesas de R$ 6.000,00,
            a abertura de um CNPJ no Simples Nacional é altamente recomendada. Esta estrutura permitirá uma
            economia tributária significativa em comparação com a tributação como pessoa física.`,
          economiaEstimada: 'R$ 2.500,00/mês',
          acoesRecomendadas: [
            'Abrir CNPJ como Simples Nacional',
            'Contratar contador especializado',
            'Regularizar emissão de notas fiscais',
            'Organizar documentação contábil',
          ],
        });
        setLoading(false);
      }, 2000);
    } catch (err) {
      setError('Erro ao realizar análise. Tente novamente.');
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Análise Tributária com IA
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Nossa IA analisa seus dados financeiros e recomenda a melhor estrutura jurídica
        para minimizar sua carga tributária.
      </Typography>

      {/* Botão de análise */}
      <Box mb={3}>
        <Button
          variant="contained"
          size="large"
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <AnalyticsIcon />}
          onClick={handleAnalisar}
          disabled={loading}
        >
          {loading ? 'Analisando...' : 'Solicitar Análise'}
        </Button>
      </Box>

      {/* Mensagem de erro */}
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {/* Resultado da análise */}
      {analise && (
        <Paper sx={{ p: 3 }}>
          <Typography variant="h5" gutterBottom color="primary">
            Resultado da Análise
          </Typography>

          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
              Estrutura Atual
            </Typography>
            <Typography variant="body1" paragraph>
              {analise.estruturaAtual}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" gutterBottom color="success.main">
              Estrutura Recomendada
            </Typography>
            <Typography variant="body1" paragraph>
              <strong>{analise.estruturaRecomendada}</strong>
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" gutterBottom>
              Justificativa
            </Typography>
            <Typography variant="body1" paragraph>
              {analise.justificativa}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" gutterBottom>
              Economia Estimada
            </Typography>
            <Typography variant="h4" color="success.main" paragraph>
              {analise.economiaEstimada}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography variant="h6" gutterBottom>
              Ações Recomendadas
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              {analise.acoesRecomendadas.map((acao, index) => (
                <Typography key={index} component="li" variant="body1" gutterBottom>
                  {acao}
                </Typography>
              ))}
            </Box>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Alert severity="info">
              <strong>Importante:</strong> Esta análise é baseada em dados automatizados.
              Consulte sempre um contador para validar as recomendações.
            </Alert>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default Analise;
